import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RegisterUserService } from '../../../services';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderCarouselSwiperComponent, LoaderCarouseTextComponent } from "./components";

@Component({
  selector: 'app-loader-carousel',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    LoaderCarouselSwiperComponent,
    LoaderCarouseTextComponent
],
  templateUrl: './loader-carousel.html',
  styleUrls: ['./loader-carousel.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
  
})
export class LoaderCarousel{
  private _registerUserService = inject(RegisterUserService);
  
  protected registerUser = this._registerUserService.registerUser;
}